'use client';
import clsx from 'clsx';

import { IcClose, Typography, theme } from '@bgzt/ui';
import { Section, Spacing } from '~/components';
import { KeywordBadge } from '~/app/search/_components';

import globalStyles from '~/styles/utils.module.css';
import styles from './SearchHistory.module.css';

type Props = {
  histories?: string[];
  onKeywordClick?(value: string): void;
  onKeywordDelete?(value: string): void;
  onHistoryClear?(): void;
};

export const SearchHistory = ({ histories, onKeywordClick, onKeywordDelete, onHistoryClear }: Props) => {
  if (!histories || histories?.length < 1) return null;
  return (
    <Section fullWidth>
      <h2 className={styles.title}>
        <Typography variant="S1" color="gray-900">
          최근 검색어
        </Typography>
      </h2>
      <Spacing height={12} />
      <ul className={clsx(styles.list, globalStyles.scrollXHidden)}>
        {histories.map((keyword) => (
          <li key={keyword} className={styles.item} onClick={() => onKeywordClick?.(keyword)}>
            <KeywordBadge>
              <Typography variant="L7" color="gray-600">
                {keyword}
              </Typography>
              <button
                type="button"
                className={styles.closeIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  onKeywordDelete?.(keyword);
                }}
              >
                <IcClose size={12} fill={theme.colors['gray-200']} />
              </button>
            </KeywordBadge>
          </li>
        ))}
        <li className={styles.item}>
          <Typography variant="L11" color="gray-500" onClick={onHistoryClear} className={styles.removeAllText}>
            전체삭제
          </Typography>
        </li>
      </ul>
    </Section>
  );
};
